import { pick } from "lodash";
import { ThreatStatusLabel } from "../../../../../../components";
import {
  useGetSampleAnalysisStatus,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { Configure, Loading } from "../../components";

import { SandboxAnalysisItem } from "../../../../@types";
import { getIsNotConfigured } from "../../utils";
import styles from "../analysis-card.module.scss";

type Props = {
  data: Array<SandboxAnalysisItem | null>;
};

const getMaliciousCount = (integrations: Array<SandboxAnalysisItem | null>) =>
  integrations
    ?.filter(Boolean)
    .filter(item => item?.classification?.toLowerCase() === "malicious").length;

const getResultsCount = (integrations: Array<SandboxAnalysisItem | null>) =>
  integrations.filter(Boolean).filter(item => item?.classification).length;

const Subtitle = ({ data }: Props) => {
  const { hash } = useLocalSampleSummaryParams();
  const { data: { dynamic_analysis: analysis = undefined } = {}, isLoading } =
    useGetSampleAnalysisStatus(hash);

  const showNoAnalysisLabel = !data.find(item => Boolean(item?.classification));

  const maliciousCount = getMaliciousCount(data);
  const resultsCount = getResultsCount(data);

  const enabledCount = Object.values(
    pick(analysis, [
      "cuckoo",
      "cape",
      "joe",
      "fireeye",
      "vmray_tcbase",
      "cisco_secure_malware_analytics"
    ])
  ).filter(item => !getIsNotConfigured(item?.additional_information)).length;

  if (isLoading) return <Loading />;

  if (!showNoAnalysisLabel)
    return (
      <ThreatStatusLabel
        className={styles.analysis_card_subtitle_classification}
        labelText={`${maliciousCount}/${Math.max(
          enabledCount,
          resultsCount
        )} Malicious`}
        threatStatus={maliciousCount ? "malicious" : "unknown"}
        showOrb={false}
        showColor
      />
    );

  if (enabledCount)
    return <span className={styles.analysis_card_subtitle}>No Analysis</span>;

  return <Configure type="INTEGRATION" />;
};

export default Subtitle;
